const apiUrl = process.env.REACT_APP_API_ENDPOINT;
const baseUrl = process.env.REACT_APP_BASE_URL;
const stripeKey = process.env.REACT_APP_API_KEY;
const cubeUrl = process.env.REACT_APP_CUBE_ENDPOINT;
const getStreamKey = process.env.REACT_APP_STREAM_API_KEY;

export { apiUrl, baseUrl, stripeKey, cubeUrl, getStreamKey };
